import { render, staticRenderFns } from "./TaskHeaderReport.vue?vue&type=template&id=47099002&scoped=true"
import script from "./TaskHeaderReport.vue?vue&type=script&lang=js"
export * from "./TaskHeaderReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47099002",
  null
  
)

export default component.exports